import TravellerListPage from '../src/pages/TravellerListPage';

export default TravellerListPage;
